'use client'

import { useEffect, useState } from 'react'
import { normalizeLocale } from '@kmerhosting/i18n'
import { siteShellCopy } from '@/lib/site-i18n'

import {
  Column,
  Grid,
  Layer,
  SkeletonPlaceholder,
  SkeletonText,
  Tile,
} from '@carbon/react'

export default function LoadingPage() {
  const [locale, setLocale] = useState(() => normalizeLocale(typeof document === 'undefined' ? 'en' : document.documentElement.lang) || 'en')
  useEffect(() => {
    const onLanguage = (event: Event) => setLocale(normalizeLocale(event instanceof CustomEvent ? event.detail : document.documentElement.lang) || 'en')
    window.addEventListener('kmerhosting:language-change', onLanguage)
    return () => window.removeEventListener('kmerhosting:language-change', onLanguage)
  }, [])
  const copy = siteShellCopy(locale)
  return (
    <main
      id="main-content"
      className="carbon-page-loading"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="sr-only">{copy.loading} KmerHosting…</span>
      <div className="carbon-page-loading__context" aria-hidden="true">
        <section className="carbon-page-loading__hero">
          <Grid>
            <Column sm={4} md={5} lg={9}>
              <SkeletonText heading width="58%" />
              <SkeletonText paragraph lineCount={3} width="82%" />
            </Column>
            <Column sm={4} md={3} lg={5}>
              <SkeletonPlaceholder className="carbon-page-loading__visual" />
            </Column>
          </Grid>
        </section>
        <section className="carbon-page-loading__cards">
          <Grid>
            {[0, 1, 2, 3].map((item) => (
              <Column key={item} sm={2} md={2} lg={4}>
                <Layer>
                  <Tile className="carbon-page-loading__tile">
                    <SkeletonPlaceholder className="carbon-page-loading__icon" />
                    <SkeletonText heading width="62%" />
                    <SkeletonText paragraph lineCount={2} width="100%" />
                  </Tile>
                </Layer>
              </Column>
            ))}
          </Grid>
        </section>
      </div>
    </main>
  )
}
